const emptyProfile = {
  active: false,
  company: {},
  menu: [],
  role: {},
  userDetail: {},
  vehicle: []
}

function normalizeProfile (profile) {
  return {
    ...emptyProfile,
    ...(profile || {}),
    company: profile?.company || emptyProfile.company,
    menu: profile?.menu || emptyProfile.menu,
    role: profile?.role || emptyProfile.role,
    userDetail: profile?.userDetail || emptyProfile.userDetail,
    vehicle: profile?.vehicle || emptyProfile.vehicle
  }
}

const getters = {
  profile: state => normalizeProfile(state.profile),
  loggedIn: state => !!state.profile
}

export default getters
